import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'lu-text-formly',
	template: ` <div [ngClass]="field.className" [innerHTML]="to.luHtml" [attr.hasValue]="!!formControl?.value"></div> `
})
export class LuTextFormlyComponent extends FieldType {}
